// extracted by mini-css-extract-plugin
module.exports = {"customRow":"footer_customRow__1jNtg","customColumn":"footer_customColumn__29zFq","email":"footer_email__3hgst"};